import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  getList: async () => {
    const body = JSON.stringify({ skip: 0, take: 1000 });
    return request(`${API_URL}/contractors/manufacturers/get`, 'post', body, {});
  },
  get: async (id) => {
    return request(`${API_URL}/contractors/manufacturers/${id}`, 'get', {}, {});
  },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/contractors/manufacturers/${id}`, 'put', body, {});
  },
  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/contractors/manufacturers/`, 'post', body, {});
  },
  delete: async (id) => {
    return request(`${API_URL}/contractors/manufacturers/${id}`, 'delete');
  },
};
